export default __webpack_public_path__ + "static/media/bootstrap_sirius.7a059502.png";